export default function getIndexName(index: string): string {
  return `${index}_${process.env.NEXT_PUBLIC_ALGOLIA_ENV}`;
}
